/**
 * Empty selection = filter inactive (matches everything). Otherwise OR-match.
 * `selected` is `(string | number)[]` because `@ui`'s `MultiSelectFilterConfig`
 * is generic over `string | number` — our own values are always strings, so
 * they're normalized to strings before comparing.
 */
export function matchesMultiSelect(values, selected) {
    if (selected.length === 0)
        return true;
    const selectedStrings = selected.map(String);
    return values.some((value) => selectedStrings.includes(value));
}
export function matchesSearch(haystack, search) {
    const query = search.trim().toLowerCase();
    if (!query)
        return true;
    return haystack.some((value) => value.toLowerCase().includes(query));
}
/**
 * Applies the search box and every configured filter. The surface knows nothing about what any
 * filter means — each one reports its own row values and they are OR-matched against the
 * selection, exactly as the Category/Visibility/File-type filters did when they were hardcoded.
 */
export function filterRows(rows, search, searchableText, filters, selections) {
    return rows.filter((row) => matchesSearch(searchableText(row), search) &&
        filters.every((filter) => { var _a; return matchesMultiSelect(filter.getValues(row), (_a = selections[filter.key]) !== null && _a !== void 0 ? _a : []); }));
}
